import { Component, WonderlandEngine } from "@wonderlandengine/api";
import { quat, vec3 } from "gl-matrix";

const tempQuat = quat.create();

/**
 * isolate-parent-rotation
 */
export class IsolateParentRotation extends Component {
  static TypeName = "isolate-parent-rotation";

  update() {
    this.object.parent?.getRotationLocal(tempQuat);
    quat.invert(tempQuat, tempQuat);
    this.object.setRotationLocal(tempQuat);
  }
}
